import React from "react";
import { List, Tag, Typography } from "antd";
import {
  OdReviewErrorType,
  OdReviewIssue,
} from "../../../services/odReview/odReview.types";
import {
  OD_REVIEW_ERROR_TYPE_LABELS,
  OD_REVIEW_ISSUE_STATUS_TAGS,
} from "./labels";
import type { ErrorTypeCounts } from "./useOdReviewQueue.utils";

const { Text } = Typography;
const { CheckableTag } = Tag;

interface IssueQueueProps {
  issues: OdReviewIssue[];
  selectedIssueId: number | null;
  onSelect: (issue: OdReviewIssue) => void;
  errorTypeCounts?: ErrorTypeCounts;
  hiddenErrorTypes?: OdReviewErrorType[];
  onToggleErrorType?: (errorType: OdReviewErrorType) => void;
}

const IssueQueue: React.FC<IssueQueueProps> = ({
  issues,
  selectedIssueId,
  onSelect,
  errorTypeCounts,
  hiddenErrorTypes = [],
  onToggleErrorType,
}) => {
  const presentErrorTypes = (
    Object.keys(OD_REVIEW_ERROR_TYPE_LABELS) as OdReviewErrorType[]
  ).filter((errorType) => (errorTypeCounts?.[errorType] ?? 0) > 0);
  const hiddenUnverifiableCount = hiddenErrorTypes.includes(
    "REFERENCIA_NO_VERIFICABLE",
  )
    ? (errorTypeCounts?.REFERENCIA_NO_VERIFICABLE ?? 0)
    : 0;

  return (
    <div>
      <Text strong style={{ display: "block", marginBottom: 12 }}>
        {`Errores encontrados (${issues.length})`}
      </Text>
      {presentErrorTypes.length > 0 && onToggleErrorType && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {presentErrorTypes.map((errorType) => (
              <CheckableTag
                key={errorType}
                checked={!hiddenErrorTypes.includes(errorType)}
                onChange={() => onToggleErrorType(errorType)}
              >
                {`${OD_REVIEW_ERROR_TYPE_LABELS[errorType]} (${errorTypeCounts?.[errorType] ?? 0})`}
              </CheckableTag>
            ))}
          </div>
          {hiddenUnverifiableCount > 0 && (
            <Text
              type="secondary"
              style={{ display: "block", marginTop: 8, fontSize: 12 }}
            >
              {`+${hiddenUnverifiableCount} referencias no verificables ocultas`}
            </Text>
          )}
        </div>
      )}
      <List
        dataSource={issues}
        locale={{ emptyText: "Sin errores encontrados." }}
        renderItem={(issue) => {
          const isSelected = issue.id === selectedIssueId;
          const statusTag = OD_REVIEW_ISSUE_STATUS_TAGS[issue.status];
          return (
            <List.Item
              key={issue.id}
              onClick={() => onSelect(issue)}
              style={{
                cursor: "pointer",
                padding: "8px 12px",
                backgroundColor: isSelected ? "#e6f4ff" : undefined,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  width: "100%",
                }}
              >
                <Text strong>{issue.error_title}</Text>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {OD_REVIEW_ERROR_TYPE_LABELS[issue.error_type]}
                  </Text>
                  <Tag color={statusTag.color}>{statusTag.label}</Tag>
                </div>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default IssueQueue;
